import { useAsset } from '@/hooks/useAsset'
import type { ComponentProps } from 'react'

type ImageAssetProps = Omit<ComponentProps<'img'>, 'src'> & {
	src: string
	className?: string
	altText?: string
}

export function ImageAsset({
	src,
	className,
	altText = '',
	...props
}: ImageAssetProps) {
	const url = useAsset(src)
	return <img alt={altText} src={url} className={className} {...props} />
}
